import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ScrollToTop from "./lib/ScrollToTop";
import SideNav from "./components/Navbar/SideNav";
import Footer from "./components/Footer/Footer";

// Pages
import LandingPage from "./pages/Landing/LandingPage";
import AboutPage from "./pages/About/AboutPage";
import ContactPage from "./pages/Contact/ContactPage";
import RealEstatePage from "./pages/RealEstate/RealEstatePage";
import SandDredgingPage from "./pages/SandDreging/SandDredgingPage";
import QuarryPage from "./pages/Quarry/QuarryPage";
import GalleryPage from "./pages/Gallery/GalleryPage";
import FarmingPage from "./pages/Farming/FarmingPage";
import TrainingViewer from "./pages/Training/TrainingDetail";

// Training Pages
import TrainingLogin from "./pages/Training/TrainingLogin";
import UpdateTrainingForm from './pages/Training/UpdateTrainingForm';
import ShabuTraining from "./pages/Training/ShabuTraining";
import CalabarTraining from "./pages/Training/CalabarTraining";
import HolyCrossTraining from "./pages/Training/HolyCrossTraining";
import KedaTraining from "./pages/Training/KedaTraining";
import MinnaTraining from "./pages/Training/MinnaTraining";
import NAQsTraining from "./pages/Training/NaqsTraining";
import TrainingEditor from "./pages/Training/TrainingEditor";
import WactCsrTraining from "./pages/Training/WactCsrTraining";
import RuralWomenTraining from "./pages/Training/RuralWomenTraining";
import FMSTITraining from "./pages/Training/FMSTITraining";
import MOFITraining from "./pages/Training/MOFITraining";
import SahelTraining from "./pages/Training/SahelTraining";
import ChangemakersTraining from "./pages/Training/ChangemakersTraining";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <SideNav />
      <Routes>
        {/* Public Pages */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />

        {/* Services */}
        <Route path="/services/chyson-foods" element={<RealEstatePage />} />
        <Route path="/services/what-we-do" element={<SandDredgingPage />} />
        <Route path="/services/training" element={<QuarryPage />} />
        <Route path="/services/training/shabu" element={<ShabuTraining />} />
        <Route path="/services/training/calabar" element={<CalabarTraining />} />
        <Route path="/services/training/holycross" element={<HolyCrossTraining />} />
        <Route path="/services/training/wactcsr" element={<WactCsrTraining />} />
        <Route path="/services/training/keda" element={<KedaTraining />} />
        <Route path="/services/training/minna" element={<MinnaTraining />} />
        <Route path="/services/training/naqs" element={<NAQsTraining />} />
        <Route path="/services/training/ruralwomen" element={<RuralWomenTraining />} />
        <Route path="/services/training/fmsti2024" element={<FMSTITraining />} />
        <Route path="/services/training/mofi" element={<MOFITraining />} />
        <Route path="/services/training/sahel23" element={<SahelTraining />} />
        <Route path="/services/training/sahel24" element={<ChangemakersTraining />} />
        <Route path="/services/farming" element={<FarmingPage />} />
        <Route path="/services/gallery" element={<GalleryPage />} />

        {/* Training Auth and Editor */}
        <Route path="/services/training/login" element={<TrainingLogin />} />
        <Route path="/services/training/new" element={<TrainingEditor />} />
        <Route path="/services/training/:training_name" element={<TrainingViewer />} />
        <Route path="/services/training/update-training/:id" element={<UpdateTrainingForm />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
